import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { ParentEntity } from "../../entity";

export class GetAllParentDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => ParentEntity)
  data!: ParentEntity[];

  @Expose()
  @IsNumber()
  count!: number;

  @Expose()
  @IsNumber()
  page!: number;

  @Expose()
  @IsNumber()
  pageSize!: number;
}
